<template>
  <v-dialog
    v-model="value"
    width="515"
    height="360"
  >
    <v-card id="report-timezone-modal">
      <h2>Report Delivery</h2>
      <v-btn
        icon
        class="close-icon"
        @click="close"
      >
        <v-icon size="20">
          $faTimes
        </v-icon>
      </v-btn>
      <span>
        Reports are scheduled to be sent at 4:00AM every day.
        <br>Please select your timezone so that you can wake up to a fresh report in your inbox every morning.
      </span>
      <v-select
        v-model="userTimezone"
        class="timezone-select"
        :items="timezones"
        return-object
        item-text="text"
        item-value="value"
        :placeholder="userTimezone.text"
      />
      <v-btn
        block
        color="primary"
        :disabled="updating"
        @click="updateUserTimezone(); $emit('apply')"
      >
        Apply
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
  import { getTimeZones } from '@vvo/tzdb'
  import { mapGetters } from 'vuex'
  import defaultTimezoneFromClientMixin from '../../helpers/default-timezone-from-client-mixin'

  export default {
    name: 'ReportTimezoneModal',
    mixins: [defaultTimezoneFromClientMixin],
    props: {
      userId: Number,
    },
    data () {
      return {
        userTimezone: { text: '', value: '' },
        updating: false,
        value: false,
      }
    },
    computed: {
      ...mapGetters({
        savedUserData: 'Users/userData',
      }),
      userOrgIds () {
        return this.savedUserData.orgs?.map(o => o.id) ?? []
      },
      timezones () {
        return getTimeZones()
          .sort((a, b) => a.rawOffsetInMinutes > b.rawOffsetInMinutes)
          .map(tz => ({ text: tz.rawFormat, value: tz.name }))
      },
    },
    mounted () {
      this.userTimezone = this.defaultTimezoneFromClientOffset
    },
    methods: {
      async updateUserTimezone () {
        try {
          this.updating = true
          const payload = { userId: this.savedUserData.id, orgs: this.userOrgIds, userTimezone: this.userTimezone.value }
          this.$store.dispatch('Users/createUserTimezone', payload)
          this.resolved()
        } finally {
          this.updating = false
        }
      },
      open () {
        this.value = true
        return new Promise((resolve, reject) => {
          this.resolved = resolve
          this.rejected = reject
        })
      },
      close () {
        this.value = false
        this.rejected()
      },
    },
  }
</script>

<style lang="scss">
#report-timezone-modal {
    background: #F9F7F3;
    padding: 40px 50px;
    position: relative;
  .close-icon {
      position: absolute;
      top: 20px;
      right: 24px;
  }
  .timezone-select input::placeholder {
    color: black;
  }
}
</style>
